/* Snackspot v2 — FAQ filter. Ported from the prototype's inline script: the pressed tab filters the
   <details> list by data-cat. Uses the hidden attribute + aria-pressed instead of inline display. */
(function () {
  'use strict';
  function init(root) {
    if (root.__ssFaq) return;
    root.__ssFaq = true;
    var tabs = root.querySelectorAll('.ftab');
    var items = root.querySelectorAll('.faq2-item');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        t.classList.add('is-on');
        t.setAttribute('aria-pressed', 'true');
        var cat = t.dataset.cat;
        items.forEach(function (i) { i.hidden = !(cat === 'all' || i.dataset.cat === cat); });
      });
    });
    // a deep link (footer → /pages/faq#business) lands on the item open
    if (location.hash) {
      var target = null;
      try { target = root.querySelector(location.hash); } catch (e) {}
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
  }
  function boot() { document.querySelectorAll('[data-ss-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector ? e.target.querySelector('[data-ss-faq]') : null; if (r) init(r); });
})();
